import script from "./resignation-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./resignation-modal.vue?vue&type=script&setup=true&lang=js"

import "./resignation-modal.vue?vue&type=style&index=0&id=fac8e2a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac8e2a6"]])

export default __exports__